module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Axe-715670bfea0031a0d5e9fe2dcd1deace.svg";